/* La pallina che si ferma come il punto dopo il titolo.

   In home il titolo grande ce l'ha da sempre: la pallina arriva rotolando da
   destra e si ferma al suo posto. Quell'effetto vale per tutti i titoli che
   adottano quello stile - le testate di pagina, la fascia dei design, come
   funziona RADAR, MY RADAR - non solo per uno.

   Il segno c'e' comunque: <span class="radar-court__ball"> e' un punto lime
   anche fermo. Qui si aggiunge solo l'arrivo, e la classe che lo prepara la
   mette questo file, cosi' senza JavaScript la pallina sta gia' al suo posto
   invece di restare fuori schermo.

   Il titolo in home no: quello ha una pallina sua, che rimbalza mentre i nomi
   cambiano, e la governa radar-title.js. Toccarla da qui le darebbe due
   padroni. */
(function (global) {
  'use strict';

  var doc = global.document;
  if (!doc) return;

  function avvia() {
    var reduced = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduced && reduced.matches) return;
    if (!('IntersectionObserver' in global)) return;

    var palline = doc.querySelectorAll('.radar-court__ball');
    if (!palline.length) return;

    var occhio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-ball-in');
        occhio.unobserve(entry.target);
      });
    }, { threshold: 0.35 });

    Array.prototype.forEach.call(palline, function (pallina) {
      // Quella della home ha gia' chi la muove.
      if (pallina.closest('.radar-making__swap, .radar-making')) return;
      var titolo = pallina.parentElement;
      if (!titolo) return;

      // La pista attorno alla pallina. Serve perche' una trasformazione sola
      // non puo' portare due curve insieme: la pista fa il viaggio in
      // orizzontale, la pallina dentro fa i rimbalzi. Il titolo in home ha
      // la sua pista scritta nel Liquid; qui la mettiamo noi, cosi' nessuno
      // dei dodici titoli deve cambiare markup.
      if (!pallina.parentElement.classList.contains('radar-ball-lane')) {
        var pista = doc.createElement('span');
        pista.className = 'radar-ball-lane';
        pista.setAttribute('aria-hidden', 'true');
        pallina.parentNode.insertBefore(pista, pallina);
        pista.appendChild(pallina);
      }

      titolo.classList.add('is-ball-armed');
      occhio.observe(titolo);
    });
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})(typeof window !== 'undefined' ? window : globalThis);
